import { uniqueId } from "lodash";
import { GQLAIUserMessage } from "./types";

export const getTempUserMessage = (text: string): GQLAIUserMessage => ({
  __typename: "UserMessage",
  id: `${Date.now()}-${uniqueId()}`,
  text: text,
});
